import React, { useState } from 'react';
import { Button, TextField, List, ListItem, ListItemText } from '@mui/material';
import { Box } from "@mui/system";

interface EditableListProps {
    value: string[];
    onChange: (updatedList: string[]) => void;
}

const EditableList: React.FC<EditableListProps> = ({ value, onChange }) => {
    const [inputValue, setInputValue] = useState('');

    const addItem = () => {
        if (inputValue.trim()) {
            const updatedList = [...value, inputValue];
            onChange(updatedList);
            setInputValue('');
        }
    };

    const removeItem = (index: number) => {
        const updatedList = [...value];
        updatedList.splice(index, 1);
        onChange(updatedList);
    };

    return (
        <Box sx={{ p: 2 }}>
            <List>
                {value.map((item, index) => (
                    <ListItem key={index}>
                        <ListItemText primary={item} />
                        <Button onClick={() => removeItem(index)}>Remove</Button>
                    </ListItem>
                ))}
            </List>
            <div>
                <div style={{ padding: 4 }}>
                    <TextField
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                    />
                </div>
                <div style={{ padding: 4 }}>
                    <Button variant="contained" onClick={addItem}>
                        Add
                    </Button>
                </div>
            </div>
        </Box>
    );
};

export default EditableList;
